import './accessible-avatar.styles.scss';
import React, { FC, Props } from 'react';
import { Avatar, AvatarProps} from '../ant-design/avatar';
import { UserOutlined } from '@ant-design/icons';
import { Badge } from 'antd';


/**
 * AccessibleAvatarProps
 *
 * @memberof AccessibleAvatar
 */
interface AccessibleAvatarProps extends AvatarProps{

    /**
     * position of the badge icon on the avatar
     */
    badgePosition?: 'bottom-left' | 'bottom-right' | 'top-left' |'top-right';
    /**
     * onclick callback function 
     */
    onAvatarClick?: () => void;
};



/**
 * A Simple Avatar Component
 */
export const AccessibleAvatar: FC<AccessibleAvatarProps> = (
    {
        badgePosition,
        onAvatarClick, 
        ...props
    }
) => {

    const defaultedProps = Object.assign({
        icon: <UserOutlined />,
        size: 52,
        shape: 'circle' as 'circle' | 'square',
        style: {cursor: 'pointer'},
        alt: 'avatar',
        ariaLabelledBy: '',
        ariaLabel: '',
        tabIndex: 0,
        role: onAvatarClick ? 'button' : undefined,
        onClick: onAvatarClick,
    }, props);

    // Render
    return (
        <div className="accessible-avatar" >
            <Badge count={<div className={`badge-${badgePosition ? badgePosition : 'bottom-right'} `} >{props.children}</div>}>
                <Avatar 
                {...defaultedProps}/>
            </Badge>
        </div>
    )
};
